// custom typefaces
import "fontsource-domine";
import "fontsource-domine/700.css";
import "fontsource-open-sans";
import "fontsource-open-sans/700.css";
import "fontsource-noto-sans-kr";
import "fontsource-noto-sans-kr/700.css";

import "prism-themes/themes/prism-vsc-dark-plus.css";
import "prismjs/plugins/line-numbers/prism-line-numbers.css";
import "prismjs/plugins/command-line/prism-command-line.css";

import QueryWrapper from "gatsby-theme-advanced/src/context/QueryWrapper";

// normalize CSS across browsers
import "./src/global/normalize.css";

// custom CSS styles
import "./src/global/_styles.scss";

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = QueryWrapper;
